import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import RemoveEntryForm from './form'

const RemoveEntryDialog = React.forwardRef(function RemoveEntryDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (entry) => setDialogState({ open: true, processing: false, entry })
  }), [setDialogState])

  return (
    <RoundedModal
      title={`Archive ${dialogState?.entry?.entryType?.entryTypeName || 'Entry'}`}
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<RemoveEntryForm entry={dialogState.entry} onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

RemoveEntryDialog.propTypes = {
  onComplete: PropTypes.func
}

RemoveEntryDialog.defaultProps = {
  onComplete: () => {}
}

export default RemoveEntryDialog
